import appConfigCoverGoDev from "./appConfigCoverGoDev.js"
import { COVERGO_EU_PREPROD } from "../consts.js"

export const coverHealthEuPreprod = {
	"studio.preprod.eu.covergo.cloud": { appConfig: appConfigCoverGoDev, envConfig: COVERGO_EU_PREPROD },
}
